import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { FileRecordVersionHistoryCallable } from "@/action-dialog/callables";
import { trackFileVersionHistoryOpened } from "@/utils/analytics";
import type { FileRecord } from "@cohesive/api-client";

export interface FileRecordVersionHistoryParams {
  record: FileRecord;
}

export function runFileRecordVersionHistoryWorkflow(
  params: FileRecordVersionHistoryParams,
): Promise<void> {
  trackFileVersionHistoryOpened({ fileRecordId: params.record.id });
  return withActionDialogLock(() =>
    FileRecordVersionHistoryCallable.call({ record: params.record }),
  );
}
